<div
  class="spinner animate-spin rounded-full border-2 border-grey-lightGrey border-t-orange"
  style="height: 100%; aspect-ratio: 1"
></div>
